<template>
    <div class="k-nav" v-if="!userAgent">
        <div class="k-title f-flex">
            <div class="k-c-title">
                <el-tabs v-model="activeName">
                    <el-tab-pane label="大闸蟹新闻" name="1">
                        <div class="k-content f-flex" >
                            <div class="k-m-content" v-for="(item,index) of crab_news" :key="index">
                                <div class="k-m-title">
                                    <a>{{item.newtitle}}</a>                                   
                                </div> 
                                <div @click="newDetail(items.id,items.title,items.newcontent)" v-for="(items,indexs) of item.data" :key="items.id">
                                    <div class="k-con f-flex">
                                        <div class="img" v-if="indexs == 0">
                                            <img :src="items.image" alt="">
                                        </div>
                                        <div class="desc" v-if="indexs == 0">
                                            <p >{{items.title}}</p>
                                            <p>{{items.describe}}</p>
                                        </div>                             
                                    </div>
                                    <p class="list f-flex" v-if="indexs !== 0">
                                        <a>{{items.title}}</a>
                                        <span>{{items.createtime}}</span>
                                    </p>   
                                </div>
                                
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="大闸蟹知识" name="2">
                        <div class="k-content f-flex" >
                            <div class="k-m-content" v-for="(item,index) of crab_knowledge" :key="index">
                                <div class="k-m-title">
                                    <a>{{item.newtitle}}</a>
                                    
                                </div> 
                                <div @click="newDetail(items.id,items.title,items.newcontent)" v-for="(items,indexs) of item.data" :key="items.id">
                                    <div class="k-con f-flex">
                                        <div class="img" v-if="indexs == 0">
                                            <img :src="items.image" alt="">
                                        </div>
                                        <div class="desc" v-if="indexs == 0" >
                                            <p>{{items.title}}</p>
                                            <p>{{items.describe}}</p>                                          
                                        </div>                              
                                    </div>
                                    <p class="list f-flex" v-if="indexs !== 0">
                                        <a>{{items.title}}</a>
                                        <span>{{items.createtime}}</span>
                                    </p>                                                 
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="大闸蟹视频" name="3">
                        <div class="k-content f-flex" >
                            <div class="k-m-content" v-for="(item,index) of crab_views" :key="index">
                                <div class="k-m-title">
                                   <a>{{item.newtitle}}</a>
                                   
                                </div> 
                                <div @click="newDetail(items.id,items.title,items.newcontent)" v-for="(items,indexs) of item.data" :key="items.id">
                                    <div class="k-con f-flex" >
                                        <div class="img" v-if="indexs == 0">
                                            <img :src="items.image" alt="">
                                        </div>
                                        <div class="desc" v-if="indexs == 0">
                                            <p >{{items.title}}</p>
                                            <p>{{items.describe}}</p>
                                        </div>                              
                                    </div>
                                   <p class="list f-flex" v-if="indexs !== 0">
                                        <a>{{items.title}}</a>
                                        <span>{{items.createtime}}</span>
                                    </p>                                                      
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="大闸蟹文化" name="4">
                        <div class="k-content f-flex">
                            <div class="k-m-content"  v-for="(item,index) of crab_culture" :key="index">
                                <div class="k-m-title">
                                    <a>{{item.newtitle}}</a>
                                   
                                </div> 
                                <div @click="newDetail(items.id,items.title,items.newcontent)" v-for="(items,indexs) of item.data" :key="items.id">
                                    <div class="k-con f-flex" >
                                        <div class="img" v-if="indexs == 0">
                                            <img :src="items.image" alt="">
                                        </div>
                                        <div class="desc" v-if="indexs == 0">
                                            <p >{{items.title}}</p>
                                            <p>{{items.describe}}</p>
                                        </div>                              
                                    </div>
                                   <p class="list f-flex" v-if="indexs !== 0">
                                        <a>{{items.title}}</a>
                                        <span>{{items.createtime}}</span>
                                    </p>                                                      
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <router-link to="/news">更多>></router-link>
        </div>       
        <!-- 移动端 -->
    </div>
    <div class="k-nav1" v-else>
        <div class="k-title1 f-flex">
            <div class="k-c-title1">
                <el-tabs v-model="activeName">
                    <el-tab-pane label="大闸蟹新闻" name="1">
                        <div class="k-content1" v-for="item of crab_news" :key="item.id">
                            <div class="k-m-content1">
                                <div class="k-m-title1">
                                    <a >{{item.newtitle}}</a>                                  
                                </div> 
                                <div @click="newDetail(items.id,items.title,items.newcontent)" v-for="(items,indexs) of item.data" :key="items.id">
                                    <div class="k-con1 f-flex" >
                                        <div class="img" v-if="indexs == 0" >
                                            <img :src="items.image" alt="">
                                        </div>                                     
                                        <div class="desc" v-if="indexs == 0" >
                                            <p >{{items.title}}</p>
                                            <p>{{items.describe}}</p>
                                        </div>                              
                                    </div> 
                                    <p class="list f-flex" v-if="indexs !== 0">
                                        <a>{{items.title}}</a>
                                        <span>{{items.createtime}}</span>
                                    </p>                                                 
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="大闸蟹知识" name="2">
                        <div class="k-content1" v-for="item of crab_knowledge" :key="item.id">
                            <div class="k-m-content1">
                                <div class="k-m-title1">
                                   <a>{{item.newtitle}}</a>
                                    
                                </div> 
                                <div @click="newDetail(items.id,items.title,items.newcontent)" v-for="(items,indexs) of item.data" :key="items.id">
                                    <div class="k-con1 f-flex" >
                                        <div class="img" v-if="indexs == 0" >
                                            <img :src="items.image" alt="">
                                        </div>                                     
                                        <div class="desc" v-if="indexs == 0" >
                                            <p >{{items.title}}</p>
                                            <p>{{items.describe}}</p>
                                        </div>                              
                                    </div> 
                                    <p class="list f-flex" v-if="indexs !== 0">
                                        <a>{{items.title}}</a>
                                        <span>{{items.createtime}}</span>
                                    </p>                                                 
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="大闸蟹视频" name="3">
                        <div class="k-content1" v-for="item of crab_views" :key="item.id">
                            <div class="k-m-content1">
                                <div class="k-m-title1">
                                    <a>{{item.newtitle}}</a>
                                    
                                </div> 
                                <div @click="newDetail(items.id,items.title,items.newcontent)" v-for="(items,indexs) of item.data" :key="items.id">
                                    <div class="k-con1 f-flex" >
                                        <div class="img" v-if="indexs == 0" >
                                            <img :src="items.image" alt="">
                                        </div>                                     
                                        <div class="desc" v-if="indexs == 0" >
                                            <p >{{items.title}}</p>
                                            <p>{{items.describe}}</p>
                                        </div>                              
                                    </div> 
                                    <p class="list f-flex" v-if="indexs !== 0">
                                        <a>{{items.title}}</a>
                                        <span>{{items.createtime}}</span>
                                    </p>                                                 
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="大闸蟹文化" name="4">
                        <div class="k-content1" v-for="item of crab_culture" :key="item.id">
                            <div class="k-m-content1">
                                <div class="k-m-title1">
                                    <a>{{item.newtitle}}</a>
                                    
                                </div> 
                                <div @click="newDetail(items.id,items.title,items.newcontent)" v-for="(items,indexs) of item.data" :key="items.id">
                                    <div class="k-con1 f-flex" >
                                        <div class="img" v-if="indexs == 0" >
                                            <img :src="items.image" alt="">
                                        </div>                                     
                                        <div class="desc" v-if="indexs == 0" >
                                            <p >{{items.title}}</p>
                                            <p>{{items.describe}}</p>
                                        </div>                              
                                    </div> 
                                    <p class="list f-flex" v-if="indexs !== 0">
                                        <a>{{items.title}}</a>
                                        <span>{{items.createtime}}</span>
                                    </p>                                                 
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <router-link to="/news">更多>></router-link>
        </div>       

    </div>
</template>

<script>
    export default {
        name:"KnowItem",
        data(){
            return{
                activeName:'1',
                crab_news:[],
                crab_culture:[],
                crab_knowledge:[],
                crab_views:[],
                image:[]
            }
        },
        mounted(){
            this.$http.get('api/index/index').then(res=>{
                this.crab_news=res.data.data.crab_news;
                this.image=this.crab_news[0].data[0].image
                this.crab_knowledge=res.data.data.crab_knowledge;
                this.crab_views=res.data.data.crab_views;
                this.crab_culture=res.data.data.crab_culture;
            })
        },
        methods:{
           newDetail(id,title,newcontent){
               console.log("gegerfefef",this.activeName)
               this.$router.push(`/newDetail?id=${id}&title=${title}&newcontent=${newcontent}&activeName=${this.activeName}`)
           }
        }
    }
</script>

<style scoped>
/* pc端 */
.k-nav{
    width: 80%;
    margin: 0 auto;
    
}
.k-title{
    width: 100%; 
    position: relative;
    text-align: center;
    align-items: center;
}
.k-title>div{
    width: 100%;
    line-height: 30px;
    font-size:10px;
    font-family:SourceHanSansCN-Bold,SourceHanSansCN;
    font-weight:bold;
    color:#6C6C6C;
}
.k-title .active{
    background-color:  #900100;
    color: white;
    font-size: 15px;
} 
.k-title>a{
    position: absolute;
    right: 10px;
    top: 2%;
    transform: translateY(-2%);
}
/deep/ .el-tabs__nav-wrap:after{
    width: 100%;
    background-color: #900100;
}
.k-title /deep/ .el-tabs__nav-wrap.is-scrollable{
    padding: 0;
}
.k-title /deep/ .el-tabs__item{
    padding: 0 10px;
    width: 33%;
    font-size: 12px;
}
.k-title /deep/ .el-tabs__item.is-active{
    color: white;
    background-color: #900100;
    font-size: 16px;
    border-bottom: none;
}
.k-title /deep/ .el-tabs__active-bar{
    background: none;
}
.k-title .el-tabs{
    width: 100%;
    line-height: 30px;
    font-size:10px;
    font-family:SourceHanSansCN-Bold,SourceHanSansCN;
    font-weight:bold;
}
.k-content{
    width: 100%;
    justify-content: space-between;
    margin-bottom: 3%;
}
.k-m-content{
    border: 1px solid #C2C2C2;
    width: 32%;
    cursor: pointer;
}
.k-m-title{
    margin: 0 auto;
    border-bottom: 1px solid #C2C2C2;
    width: 85%;
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
}
.k-m-title>a:nth-child(1){
    font-size: 14px;
    color: black;
    font-weight: 900;
}
a{
    text-decoration: none;
    color: black;
    font-size: 8px;
}
.k-con{
    width: 85%;
    margin:0 auto 2%;
}
.k-con:nth-child(1){
    margin-top:3%
}
.k-con .img img{
    width: 100%;
    height:100%;   
    
}
.k-con .img{
    width: 5rem;
    height: 4rem;
    margin-right: 2%;
}
.k-con .desc{
    width: 65%;
    min-width: 100px;
    text-align: left;
    line-height: 17px;
}
.k-con .desc p{
    -webkit-box-orient: vertical;
    display: -webkit-box;
    overflow : hidden;
}
.k-con .desc>p:nth-child(1){
    color: #900100;
    font-weight: 600;
    font-size: 10px;
    -webkit-line-clamp: 2;  
}
.k-con .desc>p:nth-child(2){
    font-weight: bold;
    font-size: 8px;
    -webkit-line-clamp: 6; 
}
.list{
    width: 85%;
    margin-left: 10%;
    margin-top: -5%;
    justify-content: space-between;
}
.list>a{
    color:#6C6C6C;;
    font-size: 10px;
    display: inline-block;
    width: 70%;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.list>span{
    font-size: 8px;
    color: black;
}

/* 移动端 */
.k-nav1{
    width: 100%;
    margin: 0 auto;
    position: relative;
}
.k-title1{
    width: 100%; 
    
}
.k-c-title1{
    width: 100%;
}
.k-title1 /deep/ .el-tabs__nav-wrap.is-scrollable{
    padding: 0;
}
.k-title1 /deep/ .el-tabs__item{
    padding: 0 5px;
    font-size: 10px;
}
.k-title1 /deep/ .el-tabs__item.is-active{
    color: white;
    background-color: #900100;
    font-size: 13px;
    border-bottom: none;
}
.k-title1 /deep/ .el-tabs__active-bar{
    background: none;
}
.k-title1 .el-tabs{
    width: 98%;
    line-height: 30px;
    font-size:10px;
    font-family:SourceHanSansCN-Bold,SourceHanSansCN;
    font-weight:bold;
    color:#6C6C6C;
    margin: 0 auto;
}
.k-title1 .active{
    background-color:  #900100;
    color: white;
    font-size: 12px;
} 
.k-title1>a{
    position: absolute;
    right: 10px;
    margin-top: 5%;
}
/* 大闸蟹新闻 */
/deep/ .el-tabs__nav-scroll{
    width: 95%;
}
.k-content1{
    width: 95%;
    margin: 5% auto;
}
.k-m-content1{
    border: 1px solid #C2C2C2;
    width: 100%;
}
.k-m-content1 .list{
    margin-top: -7%;
}
.k-m-title1{
    margin: 0 auto;
    border-bottom: 1px solid #C2C2C2;
    width: 85%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 0;
}
.k-m-title1>a:nth-child(1){
    font-size: 14px;
    color: black;
    font-weight: 900;
}
.k-con1{
    align-items: center;
    width: 85%;
    margin: 3% auto;
}
.k-con1 .desc p{
    -webkit-box-orient: vertical;
    display: -webkit-box;
    overflow : hidden;
}

.k-con1 .img{
    width: 4rem;
    height: 3rem;
    margin-right: 2%;
}
.k-con1 .img img{
    width: 100%;
    height: 100%;
}
.k-con1 div{
    width: 50%;
    text-align: left;
    line-height: 20px;
}
.k-con1 div>p:nth-child(1){
    color: #900100;
    font-weight: 600;
    font-size: 12px;
    -webkit-line-clamp: 2;
}
.k-con1 div>p:nth-child(2){
    font-weight: bold;
    font-size: 10px;
    -webkit-line-clamp: 4;
}
.list1{
    justify-content: space-around;
}
.list1 a{
    font-size: 10px;
    color:#6C6C6C;
}
</style>